import Reveal from '../Reveal';
import Section from '../Section';

/**
 * The problem this practice exists to solve.
 *
 * Names the reader's situation before any self-description, which is why it
 * sits between the hero and the founder story and carries no CTA of its own.
 *
 * Layout from the design reference
 * (docs/revamp-july-2026/handoff/Focal Point Site.dc.html): 38px heading in the
 * left column, body in a wider right column, 1fr 1.15fr at 64px gap. Collapses
 * to a single column below md, where the heading reads as a lead-in to the
 * paragraphs rather than a sibling of them.
 *
 * The band treatment and its hairline borders belong to Section, per #7919.
 *
 * The ticket says "three short paragraphs" and supplies a heading plus two,
 * matching the brief (section 4.2). What is supplied ships; no third paragraph
 * is invented.
 */
export default function ProblemSection() {
  return (
    <Section id="problem" variant="band" spacing="band">
      {/* Reveal on the two grid columns rather than on the section, so the
          heading lands a beat before the paragraphs that answer it. The two
          Reveals ARE the grid children; nesting them inside would put a
          wrapper between the grid and its columns. */}
      <div className="grid items-start gap-10 md:grid-cols-[1fr_1.15fr] md:gap-16">
        <Reveal>
          <h2 className="font-display text-[30px] font-medium leading-[1.12] tracking-[-0.03em] text-balance text-ink md:text-[38px]">
            Most organizations are stuck between AI curiosity and AI capability.
          </h2>
        </Reveal>

        <Reveal
          delay={90}
          className="flex flex-col gap-5 font-sans text-[17px] leading-[1.65] text-pretty text-body md:text-lg"
        >
          <p>
            There is no shortage of strategy. There are decks, workshops, pilots and a backlog of
            ideas. What is missing is the part where something actually gets built, adopted, and
            used every day.
          </p>
          <p>
            That gap is rarely about ambition. It is about finding someone senior enough to choose
            the right problems and technical enough to build the answer, without a six-month agency
            engagement in between.
          </p>
        </Reveal>
      </div>
    </Section>
  );
}
